export default __webpack_public_path__ + "assets/images/2.550868.webp";